import React, { useState } from "react";
import "./style.scss";
import { useChatSocket } from "./socket";
import ChatMessageWindow from "./ChatMessageWindow";
import { useChatMessageStore } from "./store";
import LastChatMessages from "./LastChatMessages";

// todo refactor to only trigger queries when chatbox is opened

export default function ChatBox({ userProfile, showMain = false }) {
  const [open, setOpen] = useState(false);
  const { chatSocket } = useChatSocket({ userProfile });
  const chatMessageStore = useChatMessageStore();
  const setShowMain = useChatMessageStore.getState().setShowMain;

  if (!chatMessageStore.showMain && !showMain) return null;

  return (
    <div>
      <div
        className={!open ? "chat-box-container" : "chat-box-container-open"}
        // style={{right: "350px"}}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div
            className="chat-box-container-header"
            onClick={() => setOpen(prev => !prev)}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>
                Chat Messages
                <span
                  style={{ fontWeight: 700, color: "#f3f4f6", fontSize: "16px", marginLeft: "5px" }}
                >
                  (Beta Version)
                </span>
              </span>
              {open && (
                <span onClick={() => setShowMain(false)}>
                  X
                </span>
              )}
            </div>
          </div>
          {open && (
            <LastChatMessages userProfile={userProfile} />
          )}
        </div>
      </div>
      {chatMessageStore.chatMessageWindows.map((messageWindow, index) => {
        return (
          <ChatMessageWindow
            key={`messageWindow-${messageWindow.id}`}
            index={index}
            userProfile={userProfile}
            chatSocket={chatSocket}
            {...messageWindow}
          />
        );
      })}
    </div>
  );
}